import { CornerEditorDockingPanelContent } from "./content/cornerEditorDockingPanelContent";
import { DockingPanel } from "./dockingPanel";

export class CornerDockingPanel {
    private readonly panel: DockingPanel;
    private visible: boolean;

    constructor(container: HTMLElement) {
        this.visible = false;

        const component = <CornerEditorDockingPanelContent />;

        this.panel = new DockingPanel(container, "dextall-studio-wall-corner-editor", "Corner properties", component, {
            style: {
                width: "360px",
                height: "548px",
                minWidth: "360px",
                minHeight: "548px",
                resize: "both",
                left: "2px",
                top: "2px",
            },
        });
        this.panel.addVisibilityListener((x: boolean) => this.visible = x);
    }

    setVisible(visibility: boolean) {
        if (this.visible === visibility) {
            return;
        }

        this.visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
